import {FileUploadDropZone} from "../../components/common/FileUploader/FileUploadDropZone";
import {Footer} from "../../components/modules/Footer/Footer";
import Head from "next/head";
import {Navbar} from "../../components/modules/Navbar/Navbar";
import type {NextPage} from "next";
import RouteNames from "../../Routes/RouteNames";
import {appColors} from "../../components/common/Colors";
import Script from "next/script";
import FaqSection from "../../components/Features/HomePage/FaqSection";
import FeatureHighlight from "../../components/Features/HomePage/FeatureHighlight";
import HomePageHeroSection from "../../components/Features/HomePage/HomePageHeroSection";
import TemplateHighlight from "../../components/Features/HomePage/TemplateHighlight";

const Page: NextPage = () => {
  return (
    <div>
      <Head>
        <title>Collage Maker | Create a Photo Collage Online For Free</title>
        <meta
          name="description"
          content="Easily create a photo collage with PhotoJoiner’s online collage maker. Choose from thousands of free collage templates, grids, stickers, text, and more!"
        />
        <meta property="og:image" content="/static/images/og-image.png" />
        <meta
          name="keywords"
          content="Collage maker, photo collage, collage, picture collage, make a collage"
        />
        <meta
          property="og:title"
          content="Collage Maker | Create a Photo Collage Online For Free"
        />
        <meta
          property="og:description"
          content="Easily create a photo collage with PhotoJoiner’s online collage maker. Choose from thousands of free collage templates, grids, stickers, text, and more!"
        />
        <meta property="og:url" content="https://www.photojoiner.com" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="MixCollage" />
        <meta name="twitter:card" content="summary_large_image" />
        <link
          rel="canonical"
          href="https://www.photojoiner.com/features/collage-maker"
        />
        <Script
          src="https://sak.userreport.com/photopix/launcher.js"
          async
          id="userreport-launcher-script"
        ></Script>
      </Head>

      <FileUploadDropZone
        location="web_home"
        routeName={RouteNames.collageEditor}
      >
        <Navbar backgroundColor={appColors.siteHeroBg} />

        <HomePageHeroSection />

        <TemplateHighlight />

        <FeatureHighlight
          heading="Your Collage, Your Way: Thousands of Layouts to Choose From!"
          subheading="From bold centerpieces to heart-shaped focal points, your vision is
            our canvas. Explore our diverse array of photo collage layouts, each
            as distinctive as your memories. With endless options to play with,
            discover the ideal photo arrangement that speaks to your style. Dive
            deeper into customization, fine-tuning cell sizes, padding, and photo
            placement to craft a collage that truly stands out."
          buttonText="Make a Collage"
          buttonOnClick={() => {}}
          isVideo={true}
          assetSrc="/static/videos/layouts.mp4"
          assetPosition="right"
        />

        <FeatureHighlight
          heading="Add Flair to Your Collages: Explore Stickers, Backgrounds, and Shapes!"
          subheading="Bring your photo collage to life with thousands of stickers, emojis, background images, and more. Choose from our hand-curated assets to express your inner artist. Whether you are looking for a heart emoji or a Valentine's background to give your collage that special care, we’ve got you covered. Plus, you can rotate or resize emojis and stickers to fit your collage perfectly. Want your collage background to repeat seamlessly? No problem; we’ve got hundreds of collage backgrounds that do exactly that."
          buttonText="Make a Collage"
          buttonOnClick={() => {}}
          isVideo={false}
          assetSrc="/static/images/flairs.png"
          assetPosition="left"
        />

        <FeatureHighlight
          heading="Collage Maker with the best text and doodle tools."
          subheading="A photo is worth a thousand words, but the correct text can add powerful meaning to your collages. That is why we created PhotoJoiner’s collage maker with the best text tools. Choose from hundreds of beautiful fonts and edit them as you see fit. You can even draw your own doodles to personalize your collage. Plus, you can fine-tune every detail, from color to shadows. With PhotoJoiner’s collage maker, you have the best tools at your fingertips to easily create a stunning photo collage."
          buttonText="Make a Collage"
          buttonOnClick={() => {}}
          isVideo={true}
          assetSrc="/static/videos/doodle.mp4"
          assetPosition="right"
        />

        <FeatureHighlight
          heading="Use the cutout tool to create unique collage stickers"
          subheading="Elevate your photo collages with our AI-driven cutout tool, allowing you to create custom stickers effortlessly. From faces to furry friends, our tool precisely extracts subjects, transforming them into eye-catching stickers. Place them on your photo collage to make a scrapbook effect."
          buttonText="Select Photos"
          buttonOnClick={() => {}}
          isVideo={false}
          assetSrc="/static/images/cutout.png"
          assetPosition="left"
        />

        <FaqSection />

        <Footer
          titleColor="#F8F8F8"
          backgroundColor="#FFFFFF"
          textColor="#333333"
          whiteLogo={false}
        />
      </FileUploadDropZone>
    </div>
  );
};

export default Page;
